import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SearchBar from '../SearchBar/SearchBar';
import LoginPanel from './LoginPanel';
import Cart from './Cart/Cart';
import Navigation from './Navigation/Navigation';
import ErrorBoundaries from './../ErrorBoundaries/ErrorBoundary';
import Logo from './Logo';
import * as commonCallsActionCreators from '../../../actionCreators/common';
import * as registerActions from '../../../actionCreators/auth';
import * as cartActions from '../../../actionCreators/cart';
import * as dittoCallsActionCreators from '../../../actionCreators/ditto';
import './MainNav.scss';
import AuthModal from 'desktop/components/AuthModal/AuthModalLoadable';
import getSetCookie from '../../../cookie';
import { getQueryParam } from '../../../utils/helper';
import { Link } from 'react-router-dom';

class MainNav extends Component {

    static propTypes = {
        mainNavigationData: PropTypes.any,
        loginStatus: PropTypes.bool,
        loginLoader: PropTypes.bool,
        showCart: PropTypes.bool,
        userInfo: PropTypes.any,
        login: PropTypes.bool,
        shortListData: PropTypes.object,
        cartData: PropTypes.object,
        toggleCart: PropTypes.func,
        isCartCount: PropTypes.any,
        isWishlistCount: PropTypes.number,
        redisCommonData: PropTypes.any
    }

    constructor(props) {
        super(props);
        this.handleScroll = this.handleScroll.bind(this);
        const type = getQueryParam(this.props.location.search.substr(1), 'type');
        this.state = {
            showGoldAdded: true,
            showMenu: true,
            userSelectedMenuVisibility: false,
            scrolledToTop: true,
            showLoginPopUp: Boolean(type) || false,
            openTab: 'signin'
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        const { isCartCount, cartActions, userInfo, dittoCallsAction, askUserLogin, loginStatus, commonCallsAction, location } = this.props;
        if (prevProps.isCartCount !== isCartCount && isCartCount !== 0) {
            cartActions.getCart();
        }
        if (getSetCookie.getCookie('isDittoID') === '' && userInfo && userInfo.result.dittos && userInfo.result.dittos.length && Boolean(parseInt(getSetCookie.getCookie('isLogined'), 10))) {
            const dittoId = userInfo.result.dittos[0];
            if (dittoId) {
                getSetCookie.setCookie('isDittoID', dittoId);
                localStorage.setItem('ditto-platform', userInfo.result.ditto && userInfo.result.ditto.platform);
            }
        }
        if (prevProps.userInfo !== userInfo && (getSetCookie.getCookie('guest_dittoid') !== '' && getSetCookie.getCookie('isLogined') === '1')) {
            dittoCallsAction.saveUpdateDitto(getSetCookie.getCookie('isDittoID'));
            dittoCallsAction.addNewDitto(getSetCookie.getCookie('isDittoID'));
            commonCallsAction.dittoAuth(getSetCookie.getCookie('isDittoID'));
            localStorage.setItem('ditto-platform', 'desktop');
            document.cookie = 'guest_dittoid=;expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=.lenskart.com;path=/';
        }
        if ((!loginStatus && prevProps.askUserLogin !== askUserLogin && askUserLogin)) {
            this.openLoginPopup();
        }
        if ((loginStatus && window.location.pathname.indexOf('/customer/') !== -1 && prevProps.askUserLogin !== askUserLogin && !askUserLogin)) {
            this.closeLoginPopup();
        }

        // This condition is case when user comes from retrypayment page.
        if (location.state && location.state.redirectUrl && prevProps.loginStatus !== loginStatus && loginStatus) {
            window.location.href = 'https://www.lenskart.com/customer/account/#/';
        }
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    openLoginPopup = () => {
        this.setState({
            showLoginPopUp: true,
            openTab: 'signin'
        });
    }
    closeLoginPopup = () => {
        clearInterval(window.secondsTimer);
        this.setState({
            showLoginPopUp: false
        });
    }

    handleScroll() {
        const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop;
        const { section } = this.props;
        if (scrollTop > 30) {
            if (!this.props.isYotpoWidgets) {
                this.props.commonCallsAction.setYotpoWidgetsState({ isYotpoWidgets: true });
            }
            if (!this.state.userSelectedMenuVisibility) {
                this.setState({ showMenu: false, scrolledToTop: false });
                if (section === 'cat') {
                    document.body.classList.add('scrolltop');
                }
            } else {
                this.setState({ scrolledToTop: false });
                if (section === 'cat') {
                    document.body.classList.remove('scrolltop');
                }
            }
        } else {
            this.setState({ showMenu: true, scrolledToTop: true });
            if (section === 'cat') {
                document.body.classList.remove('scrolltop');
            }
        }
    }

    cartOmniture(data) {
        const { userInfo, login } = this.props;
        const cxid = userInfo === null ? '' : userInfo.result.id;
        let productId = '';
        let cartLenskartPrice = '';
        let quanTityValue = '';
        let productTypeValue = '';
        let productOptionValue = '';
        let frameTypeValue = '';
        const cartProductId = [];
        const lenskartPrice = [];
        const quanTity = [];
        const productType = [];
        const productOption = [];
        const subCategory = [];
        let subCategoryStr = '';
        const addOn = [];
        let optionsPrice = {};
        const frametype = [];
        data.forEach(cartItem => {
            subCategory.push(cartItem.subcategory);
            subCategoryStr = subCategory.toString().replace(/,/g, '|').toLowerCase();
            cartProductId.push(cartItem.productId);
            productId = cartProductId.toString().replace(/,/g, '|').toLowerCase();
            quanTity.push(cartItem.quantity);
            quanTityValue = quanTity.toString().replace(/,/g, '|').toLowerCase();
            productType.push(cartItem.productTypeValue);
            productTypeValue = productType.toString().replace(/,/g, '|').toLowerCase();
            frametype.push(cartItem.frameType);
            frameTypeValue = frametype.toString().replace(/,/g, '|').toLowerCase();
            if (cartItem.catalogPrices.length > 2) {
                lenskartPrice.push(cartItem.catalogPrices[2].value);
                cartLenskartPrice = lenskartPrice.toString().replace(/,/g, '|').toLowerCase();
            } else {
                cartItem.catalogPrices.forEach(prices => {
                    if (prices.name === 'Lenskart Price') {
                        lenskartPrice.push(prices.value);
                        cartLenskartPrice = lenskartPrice.toString().replace(/,/g, '|').toLowerCase();
                    }
                });
            }
            cartItem.options.forEach(productOptionsType => {
                productOption.push(productOptionsType.type);
                productOptionValue = productOption.toString().replace(/,/g, '|').toLowerCase();
            });
            cartItem.options.forEach(productOptionsType => {
                productOptionsType.catalogPrices.forEach(catalogOptions => {
                    optionsPrice = catalogOptions.value;
                });
                addOn.push({ addonid: productOptionsType.oid, addontype: productOptionsType.type, addonprice: optionsPrice, addonbaseproduct: cartItem.productId });
            });
        });
        window.dtm.LenskartRewamp.slideCart.click.cartSummary(cxid, productId, cartLenskartPrice, quanTityValue, productTypeValue, productOptionValue, addOn, login, frameTypeValue, subCategoryStr);
        sessionStorage.setItem('dtmOnLoadData', 'cartSummary');
    }

    hideCart = () => {
        this.props.commonCallsAction.toggleCart(false);
    }

    hideGoldAdded = () => {
        this.setState({ showGoldAdded: false });
    }

    showWishList = () => {
        const { shortListData, wishlistTrue, section, loginStatus, commonCallsAction } = this.props;
        window.dtm.LenskartRewamp.header.click.headerClick(section, 'shortlist', loginStatus);
        const productId = [];
        if (shortListData.result.numberOfProducts > 0) {
            if (shortListData.result.productList) {
                shortListData.result.productList.forEach(data => {
                    productId.push(data.id);
                });
            }
        }
        if (wishlistTrue === false) {
            window.dtm.LenskartRewamp.Listing.load.headerShortlist(productId.toString());
            commonCallsAction.showWishlist(true);
        } else {
            commonCallsAction.showWishlist(false);
        }
    }

    showMenu = () => {
        this.setState({ showMenu: true, userSelectedMenuVisibility: true });
    }

    hideMenu = () => {
        this.setState({ showMenu: false, userSelectedMenuVisibility: false });
    }
    cartClickHandler = () => {
        const { section, loginStatus, commonCallsAction } = this.props;
        window.dtm.actiontype = 'view';
        window.dtm.LenskartRewamp.header.click.headerClick(section, 'CART', loginStatus);
        commonCallsAction.toggleCart(true);
    }

    render() {
        const { section, shortListData, loginStatus, cartData, redisCommonData, location, appLogo, askUserLogin, login, registerActions } = this.props;
        const locationQuery = location.search;
        const loyaltyAddedHtml = redisCommonData.LOYALTY_ADDED_HTML ? redisCommonData.LOYALTY_ADDED_HTML
            : '<div class="gold-added-close">&#10005;</div><div><img class="gold-logo" style="margin-top: -20px;" src="/logo_lk_gold_aura.png"/></div><div class="gold-added-info"><span class="gold-added-info-title">Gold membership added to cart!</span><br/><span class="gold-added-info-content">Please select your 2nd pair of eyeglass now</span><div><a href="/loyalty" target="_blank">Know More</a></div></div>';

        let isLoyaltyProductAdded = false;
        if (cartData && cartData.result) {
            cartData.result.items.forEach(data => {
                if (!isLoyaltyProductAdded && data.classification === 'loyalty_services') {
                    isLoyaltyProductAdded = true;
                }
            });
        }

        const navData = this.props.mainNavigationData && this.props.mainNavigationData.header;
        const rightNavData = this.props.mainNavigationData && this.props.mainNavigationData.rightBarNav;
        return (
            <div className="header-inner row mainNav">
                <div className="mainNav_container">
                    {(this.state.showLoginPopUp || location.search.indexOf('type=login') > -1) &&
                        <AuthModal
                            allowSignUp
                            openTab={this.state.openTab}
                            askUserLogin={askUserLogin}
                            hideLogin={() => {
                                clearInterval(window.secondsTimer);
                                this.setState({
                                    showLoginPopUp: false
                                });
                            }}
                        />}
                    {this.props.showCart &&
                        <ErrorBoundaries><Cart cartOmniture={data => { this.cartOmniture(data); }} hideHandler={this.hideCart} /></ErrorBoundaries>}
                    <div id="topNavigationBar" className={`mainNav_top is-${!this.state.showMenu ? 'scroll' : 'no-scroll'}`}>
                        <div className={`middle is-${!this.state.showMenu ? 'scroll' : 'no-scroll'}`}>
                            <div className="lenskart-brand">
                                <Logo appLogo={location.pathname === '' ? 'https://static.lenskart.com/media/desktop/img/site-images/logo.svg' : appLogo} />
                                {
                                    !this.state.scrolledToTop && this.state.showMenu && this.state.userSelectedMenuVisibility &&
                                    <i className="fa fa-times mainNav_closeMenu" aria-hidden="true" onClick={() => this.hideMenu()}></i>
                                }
                            </div>
                            <SearchBar {...this.props} />
                            <div className="fb-30 layout justify-content-end margin-l20">
                                <div className="mainNav_details">
                                    <LoginPanel
                                        {...this.props}
                                        loginStatus={login}
                                        openLoginTab={() => {
                                            this.setState({
                                                showLoginPopUp: true,
                                                openTab: 'signin'
                                            });
                                            registerActions.resetMobileLoginProps();
                                        }}
                                        openSignUpTab={() => {
                                            this.setState({
                                                showLoginPopUp: true,
                                                openTab: 'signup'
                                            });
                                        }}
                                    />
                                    <div className="order-status">
                                        {login && <Link to={{ pathname: '/customer/account/' }} title="Track Order" onClick={() => { window.dtm.LenskartRewamp.header.click.headerClick(section, 'track-order', loginStatus); }}>
                                            <div className="mainNav_name">
                                                <span>
                                                    Track Order
                                            </span>
                                            </div>
                                        </Link>}
                                        {!login && <Link to={{ pathname: '/track-order' }} title="Track Order" onClick={() => { window.dtm.LenskartRewamp.header.click.headerClick(section, 'track-order', loginStatus); }}>
                                            <div className="mainNav_name">
                                                <span>
                                                    Track Order
                                            </span>
                                            </div>
                                        </Link>}
                                    </div>
                                    <div className="" id="shortList">
                                        <a onClick={this.showWishList} className="pos-rel">
                                            <i className="heart-icon nav-icon"></i>
                                            {shortListData.result.numberOfProducts > 0 && <span className="mainNav_nav-count-text shortlist-text pos-abs">
                                                {shortListData.result.numberOfProducts}</span>}
                                            <span className="mainNav_nav-count">
                                                Shortlist
                                            </span>
                                        </a>
                                    </div>
                                    <div className="">
                                        <a onClick={this.cartClickHandler} className="pos-rel">
                                            <i className="cart-icon nav-icon"></i>
                                            {cartData.result.itemsCount > 0 && <span className="mainNav_nav-count-text pos-abs">
                                                {cartData.result.itemsCount}</span>}
                                            <span className="mainNav_nav-count">Cart
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            {locationQuery && locationQuery.indexOf('gold_add=1') !== -1 && isLoyaltyProductAdded &&
                                <div className={`col-sm-12 gold-added-container text-center ${(this.state.showGoldAdded ? '' : ' closed')}`} onClick={this.hideGoldAdded} dangerouslySetInnerHTML={{ __html: loyaltyAddedHtml }}></div>
                            }
                        </div>
                        <Navigation navData={navData} rightNavData={rightNavData} isMenuHidden={!this.state.showMenu} location={location} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    toggleCart: state.common.toggleCart,
    showCart: state.common.showCart,
    isCartCount: state.common.isCartCount,
    isWishlistCount: state.common.isWishlistCount,
    cartData: state.cart.cartData,
    productData: state.product.productData,
    categoryData: state.category.categoryData,
    login: state.common.login,
    appLogo: state.common.appLogo,
    userInfo: state.common.userInfo,
    askUserLogin: state.common.askUserLogin,
    isYotpoWidgets: state.common.isYotpoWidgets
});

function mapDispatchToProps(dispatch) {
    return {
        commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
        cartActions: bindActionCreators(cartActions, dispatch),
        registerActions: bindActionCreators(registerActions, dispatch),
        dittoCallsAction: bindActionCreators(dittoCallsActionCreators, dispatch)
    };
}

MainNav.defaultProps = {
    redisCommonData: {}
};

export default connect(mapStateToProps, mapDispatchToProps)(MainNav);
